import React from 'react';
import {ReactComponent as TransportIcon} from '../../assets/icons/Hardware/car.svg';
import {ReactComponent as MeetingRoomIcon} from '../../assets/icons/Hardware/meetingRoom.svg';
import {ReactComponent as ProjectorIcon} from '../../assets/icons/Hardware/projector.svg';
import {ReactComponent as TabletIcon} from '../../assets/icons/Hardware/tablet.svg';
import {ReactComponent as EmptyIcon} from '../../assets/icons/Hardware/empty.svg';



import SVGIcon from '../SvgIcon';

export const hardwareList=[
  { value:'transport', icon:<SVGIcon svg={TransportIcon}/>},
  {value:'meetingRoom', icon:<SVGIcon viewBox={'0 0 512 512'} svg={MeetingRoomIcon}/>},
  {value:'projector', icon:<SVGIcon viewBox={'0 0 512 512'} svg={ProjectorIcon}/>},
  {value:'tablet', icon:<SVGIcon viewBox={'0 0 512 512'} svg={TabletIcon}/>},
  {value:'empty', icon:<SVGIcon fontSize='1.5rem' viewBox={'0 0 512 512'} svg={EmptyIcon}/>},

];